import { ADMIN_FUNCTIONS, SC_MODULES } from '@app/constants/sc.modules';
import userIcon from '@app/assets/images/icons/ic/calendar.svg';
import Attendance from '@modules/school-service/pages/Income/AttendancePage';
import { IRouteConfig } from '../route.types';

const attendanceRoutes: IRouteConfig[] = [
    {
        name: 'BẢNG ĐIỂM DANH',
        icon: userIcon,
        isMenu: true,
        isRoute: true,
        exact: false,
        moduleId: SC_MODULES.SERVICE,
        functionId: ADMIN_FUNCTIONS.ATTENDANCE_PACKAGE,
        link: '/attendance',
        path: '/attendance',
        main: () => <Attendance />,
    },
];

export default attendanceRoutes;
